import { Notification03Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { Head, router } from "@inertiajs/react";
import Dashboard from "@/components/dashboard";
import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import type HomeUser from "@/types/serializers/HomeUser";

interface Props {
	user: HomeUser;
	notification_preferences_enabled: boolean;
}

export default function Edit({
	user,
	notification_preferences_enabled,
}: Props) {
	const handleToggle = (checked: boolean) => {
		router.patch("/notification_preferences", {
			notification_preferences_enabled: checked,
		});
	};

	return (
		<>
			<Head title="Nastavení upozornění" />
			<Dashboard user={user}>
				<div className="flex flex-1 flex-col gap-6 p-4 lg:p-6">
					<div className="flex items-center gap-3">
						<div className="flex size-10 items-center justify-center rounded-lg bg-primary/10">
							<HugeiconsIcon
								icon={Notification03Icon}
								strokeWidth={2}
								className="size-5 text-primary"
							/>
						</div>
						<div>
							<h2 className="font-semibold text-2xl">Nastavení upozornění</h2>
							<p className="text-muted-foreground text-sm">
								Spravujte e-mailová upozornění
							</p>
						</div>
					</div>

					<Card>
						<CardHeader>
							<CardTitle>E-mailová upozornění</CardTitle>
							<CardDescription>
								Nastavte, jaká e-mailová upozornění chcete dostávat.
							</CardDescription>
						</CardHeader>
						<CardContent className="space-y-6">
							<div className="flex items-center justify-between gap-4">
								<div className="space-y-0.5">
									<Label htmlFor="notifications-enabled" className="text-base">
										Povolit e-mailová upozornění
									</Label>
									<p className="text-muted-foreground text-sm">
										Dostávejte upozornění o expirujících dokladech, ověřeních a
										nových přihlášeních.
									</p>
								</div>
								<Switch
									id="notifications-enabled"
									checked={notification_preferences_enabled}
									onCheckedChange={handleToggle}
								/>
							</div>

							<div className="rounded-lg border bg-muted/50 p-4">
								<p className="font-medium text-sm">Typy upozornění:</p>
								<ul className="mt-2 space-y-1 text-muted-foreground text-sm">
									<li>
										• Upozornění na expirující doklady (30, 7 a 1 den předem)
									</li>
									<li>
										• Upozornění na expirující ověření klientů (30, 7 a 1 den
										předem)
									</li>
									<li>• Upozornění při novém přihlášení do účtu</li>
									<li>• Upozornění při změně hesla nebo e-mailu</li>
								</ul>
							</div>

							<p className="text-muted-foreground text-xs">
								Kritická bezpečnostní upozornění (obnovení hesla, ověření
								e-mailu) jsou odesílána vždy bez ohledu na toto nastavení.
							</p>
						</CardContent>
					</Card>
				</div>
			</Dashboard>
		</>
	);
}
